import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div data-testid="not-found-page" className="max-w-3xl mx-auto px-4 py-24 text-center">
            <div className="font-heading text-7xl font-bold text-brand-gold">404</div>
            <h1 className="mt-4 font-heading font-bold text-2xl sm:text-3xl text-brand-ink">Página não encontrada</h1>
            <p className="mt-3 text-brand-inkSoft text-sm sm:text-base">O link pode estar incorreto ou a página foi removida.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
                <Link to="/" data-testid="not-found-home-link" className="px-6 py-3 bg-brand-ink text-white text-sm font-semibold rounded-sm hover:bg-brand-gold transition-colors">Voltar ao início</Link>
                <Link to="/produtos" data-testid="not-found-products-link" className="px-6 py-3 border border-brand-border text-brand-ink text-sm font-semibold rounded-sm hover:border-brand-ink transition-colors">Ver produtos</Link>
            </div>
        </div>
    );
}
